import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as newApi from "../../api/apiCollection"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './product.css';
import { Link, useNavigate } from 'react-router-dom';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { setProductSizes } from "../../model/reducer/productSizesReducer";
import { clearAllFilter, setFilterCategory, setFilterSection, setFilterSort } from '../../model/reducer/productFilterReducer';
import Loader from '../loader/Loader';
import 'react-loading-skeleton/dist/skeleton.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import   'swiper/css/autoplay';

import ProductCard from './ProductCard';
import StoryCard from './StoryCard';


const ProductContainer = React.memo(({ section, index }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { cssmode } = useSelector(state => state.cssmode)

    const shop = useSelector(state => state.shop);
    const [promotionImage, setPromotionImage] = useState(null)
    
    
    useEffect(() => {
        const promotionImageBelowSection = shop?.shop?.offers?.filter((offer) => offer?.position == "below_section");
        const image = promotionImageBelowSection?.filter((offer) => {
            return offer?.section?.title == section?.title
        })
        setPromotionImage(image)
    }, [section])

    const handleViewMore = () => {
        dispatch(setFilterCategory({ data: section?.category_ids }));
        dispatch(setFilterSection({ data: section?.id }))
        navigate("/products")
    }

    return (
        <>
            {section?.products?.length > 0 ?
                <section id="products" style={cssmode == "dark" ?
                    section?.background_color_for_dark_theme != "" ? { backgroundColor: section?.background_color_for_dark_theme } :
                        { backgroundColor: "var(--body-background-color)" }
                    :
                    section?.background_color_for_light_theme != "" ?
                        { backgroundColor: section?.background_color_for_light_theme } :
                        { backgroundColor: "var(--body-background-color)" }
                }>
                    <div className="container">
                        <>
                            <div className=''>
                                <div className='category_section_header product_section row flex-column' >
                                    <div className="row rowcustom d-flex product_title_content justify-content-between align-items-center col-md-12">
                                        <div className='col-md-12 col-12 d-flex justify-content-between align-items-center'>

                                                                                   <div>
                                            <div className="product-title-content-container">
                                                <h2>{section.title?.length > 50 ? section.title?.substring(0, 50) + "..." : section.title}</h2>
                                                <p className=' d-md-block'>{section.short_description?.lenght > 70 ? section.short_description?.substring(0, 70) + "..." : section.short_description}</p>
                                            </div>
                                        </div>
                                        {section?.products?.length > 5 ? <div className='d-flex align-items-center flex-md-row flex-column'>
                                            <div>
                                                <span className="d-flex h3 ms-4" onClick={() => {
                                                    handleViewMore()
                                                }}>{t('see_all')}</span>
                                            </div>
                                            <div className='d-flex'>
                                            <button className={` prev-arrow-category stylearrow prev-arrow-section-${index}`}><IoMdArrowBack fill='black' size={20} /></button>
                                                <button className={` next-arrow-category stylearrow next-arrow-section-${index}`}><IoMdArrowForward fill='black' size={20} /></button>
                               
                                                {/* <button className={` prev-arrow-section prev-arrow-section-${index}`}><IoMdArrowBack fill='black' size={20} /></button>
                                                <button className={` next-arrow-section next-arrow-section-${index}`}><IoMdArrowForward fill='black' size={20} /></button> */}
                                            </div>
                                        </div> : null}
 
                                        </div>

                                            <div className="borderheading"></div>
                                    </div>
                                
                                    <div dir="rtl" className="product_section_content ">
                                        <Swiper
                                            modules={[Navigation, Pagination, Autoplay]}
                                            navigation={{
                                                prevEl: `.prev-arrow-section-${index} `,
                                                nextEl: `.next-arrow-section-${index}`,
                                            }}
                                            loop={false}
                                            // autoplay={{
                                            //     delay: 0, // Adjust the delay as needed (in milliseconds)
                                            //     disableOnInteraction: false, // Optional: disable autoplay when interacting with the slider
                                            // }}
                                            speed={3000} // Adjust the transition speed as needed (in milliseconds)
        

                                            pagination={{ clickable: true }}
                                            breakpoints={{
                                                1200: {
                                                    slidesPerView: 5,
                                                    spaceBetween: 10
                                                },
                                                1024: {
                                                    slidesPerView: 4.5,
                                                    spaceBetween: 10
                                                },
                                                768: {
                                                    slidesPerView: 3.5,
                                                    spaceBetween: 10
                                                },
                                                500: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 10
                                                },
                                                300: {
                                                    slidesPerView: 1.5,
                                                    spaceBetween: 10
                                                },
                                            }}>
                                            {section?.products?.map((product, index) => {
                                                // Debug: Log section data
                                              
                                                
                                                // Check if this is a stories section
                                                if (section?.product_type === "stories" && section?.stories && section?.stories !== "null" && section?.stories !== "") {
                                                    try {
                                                        const storiesData = JSON.parse(section.stories);
                                                        
                                                        
                                                        const storyForProduct = storiesData.find(story => 
                                                            story.product_id === product.id.toString() || 
                                                            story.product_id === product.id
                                                        );
                                                        
                                                       
                                                        
                                                        // Check if story is expired
                                                        if (storyForProduct) {
                                                            const now = new Date();
                                                            const endDate = new Date(storyForProduct.end_date);
                                                            
                                                            if (now > endDate) {
                                                              
                                                                return null; // Skip expired stories
                                                            }
                                                            
                                                            return (
                                                                <SwiperSlide key={index}>
                                                                    <StoryCard product={product} storyData={storyForProduct} />
                                                                </SwiperSlide>
                                                            );
                                                        }
                                                    } catch (error) {
                                                        console.error('Error parsing stories data:', error);
                                                    }
                                                }
                                                
                                                return (
                                                    <SwiperSlide key={index}>
                                                        <ProductCard product={product} />
                                                    </SwiperSlide>
                                                );
                                            }).filter(Boolean)} {/* Remove null items */}
                                        </Swiper>
                                    </div>


                                </div>

                            </div>
                        </>
                    </div>
                </section >
                : null}
            {promotionImage?.map((offer) => (
                <div className='col-md-12  col-12 container promotion-img' key={offer?.id} onClick={() => {
                    if (offer?.category) {
                        dispatch(setFilterCategory({ data: offer?.category?.id.toString() }));
                        navigate("/products");
                    } else if (offer?.product) {
                        navigate(`/product/${offer.product.slug}`);
                    } else if (offer?.offer_url) {
                        window.open(offer?.offer_url, "_blank");
                    }
                }}>
                    <img className={`offerImages ${offer?.category ? "cursorPointer" : ""} ${offer?.product ? "cursorPointer" : ""} ${offer?.offer_url ? "cursorPointer" : ""}`} src={offer.image_url} alt="offers" />
                </div>
            ))}
        </>
    );
});

export default ProductContainer;